import { Calendar, momentLocalizer } from "react-big-calendar";

import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useState } from "react";

import moment from "moment/moment";
import Card from "./../../../shared/components/Card";
const DnDCalendar = withDragAndDrop(Calendar);

export default function ProductionSchedule({ events }) {
  const localizer = momentLocalizer(moment);
  return (
    <>
      <Card>
        <Card.Header>
          <div className="d-flex justify-content-end mb-2">
            <div className="col-3">
              <select className="form-control">
                <option value="">Ordre de production</option>
                <option value="">Opérations</option>
                <option value="">Demande d’approvisionnement</option>
              </select>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <DnDCalendar
            localizer={localizer}
            startAccessor="start"
            endAccessor="end"
            style={{ height: "100vh" }}
            events={events}
          />
        </Card.Body>
      </Card>
    </>
  );
}
